// Stable anonymous id so a guest's projects persist and can be claimed on sign-up.
export function getGuestId() {
  let g = localStorage.getItem("buydubai_guest");
  if (!g) {
    g = "g_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    localStorage.setItem("buydubai_guest", g);
  }
  return g;
}
